<template>
  <div id="app">
    <IEScreen v-if="isIE" />
    <div v-else>
      <router-view />
      <LayoutNav :visible="layoutNavVisible" @on-close="toggleLayoutNav" />
      <LayoutNavBtn
        @click.native="toggleLayoutNav"
        :visible="layoutNavVisible"
      />
      <!-- <Aviso @close="toggleAviso" :visible="avisoVisible" />
      <Tycos @close="toggleTycos" :visible="tycosVisible" />
      <Cookies @close="toggleCookies" :visible="cookiesVisible" />-->
      <ModalPI @close="toggleModal"  :visible="modalVisible"/>

      <!-- <Aviso @close="toggleAviso" :visible="avisoVisible" />
      <Aviso :visible="avisosVisible" @close="avisosVisible = false" />
      <Tycos :visible="termVisible" @close="termVisible = false" />
      <Cookies :visible="cookiessVisible" @close="cookiessVisible = false" /> -->
      <ModalPI :visible="modalPIVisible"  @close="modalPIVisible = false"/>
     
      <div class="bannerCookies" id="allowCookies">
        <p>
          Este sitio web utiliza cookies. Para obtener más información, puedes
          consultar nuestra Política de Cookies. Al continuar navegando aceptas
          la
          <a @click="$router.push('/cookies')" > POLÍTICA DE COOKIES</a
          >, la <a @click="$router.push('/politics')">POLÍTICA DE PRIVACIDAD</a> y los
          <a @click="$router.push('/tycos')">TÉRMINOS Y CONDICIONES</a> de este sitio
          web.
        </p>
        <button class="btn-cookies" id="allowCook" @click="Cookies()">
            CERRAR
          </button>
      </div>
    </div>
  </div>
</template>

<script>
import IEScreen from "@/components/IEScreen";
import LayoutNav from "@/components/LayoutNav";
import LayoutNavBtn from "@/components/LayoutNavBtn";
// import Tycos from "@/components/Tycos";
// import Aviso from "@/components/Aviso";
// import Cookies from "@/components/Cookies";
import ModalPI from "@/components/ModalPI";
import gsap, { ScrollToPlugin } from "gsap/all";

gsap.registerPlugin(ScrollToPlugin);

export default {
  name: "App",
  components: {
    IEScreen,
    LayoutNav,
    LayoutNavBtn,
    // Tycos,
    // Aviso,
    // Cookies,
    ModalPI
  },

  data: () => ({
    avisosVisible: false,
    termVisible: false,
    cookiessVisible: false,
    modalPIVisible: false
  }),

  mounted() {
    this.Cookies();
  },
  computed: {
    layoutNavVisible() {
      return this.$store.state.layoutNavVisible;
    },
    tycosVisible() {
      return this.$store.state.tycosVisible;
    },
    avisoVisible() {
      return this.$store.state.avisoVisible;
    },
    cookiesVisible() {
      return this.$store.state.cookiesVisible;
    },
    modalVisible() {
      return this.$store.state.modalVisible;
    },
    isIE() {
      const ua = window.navigator.userAgent;
      return /MSIE|Trident/.test(ua);
    },
  },

  methods: {
    Cookies() {
      const botonCerrarCookies = document.getElementById("allowCook");
      const avisoCookies = document.getElementById("allowCookies");

      if (!localStorage.getItem("cookies-aceptadas")) {
        avisoCookies.classList.add("activo");
      }
      botonCerrarCookies.addEventListener("click", () => {
        console.log("me diste click");
        avisoCookies.classList.remove("activo");
        localStorage.setItem("cookies-aceptadas", true);
      });
    },
    toggleLayoutNav() {
      this.$store.commit("toggleLayoutNav");
    },
    toggleAviso() {
      this.$store.commit("toggleAviso");
    },
    toggleTycos() {
      this.$store.commit("toggleTycos");
    },
    toggleCookies() {
      this.$store.commit("toggleCookies");
    },
    toggleModal() {
      this.$store.commit("toggleModal");
    },
  },
};
</script>

<style lang="stylus">
@import './styles/main.styl';

.bannerCookies{
    display: none;
    color: aliceblue;
    background: rgba(5, 5, 5, 0.8);
    /* margin-left: 2%; */
    position: fixed;
    bottom: -80px;
    z-index: 100;
    /* justify-content: space-between; */
    width: 103%;
    margin: -1.5%;
    padding: 0vw 0vw 16vw 1vw;
    height: 27%;
  }  
  .bannerCookies.activo {

    display: flex;
    align-items: start;
    justify-content: space-around;
    flex-direction: row;
    
}

  .bannerCookies p {
    margin: 3% 5%;
    color: aliceblue;
    width:75%;
    margin-left: -3%;
    font-size: 1.3vw;
 }

 .bannerCookies a {
    color: -webkit-link;
    cursor: pointer;
    text-decoration: underline;
}

.btn-cookies {
   color: #fff;
   border: 0.3vw solid white;
   padding: 0.5em 0.7em;
   background: transparent;
   border-width: medium;
   margin: 3vw 1vw 1vw -20vw;
}

.bannerCookies p a {
    color: #00beff;
}

@media only screen and (max-width: 768px) {
    
.bannerCookies {
    display: none;
    color: aliceblue;
    background: rgba(5, 5, 5, 0.8);
    padding: 1vw 3vw 47vw 1vw;
    /* margin-left: 2%; */
    position: fixed;
    min-width: 100%;
    bottom: 3.5px;  
 }

 .bannerCookies.activo {
    display: flex;
    align-items: start;
    justify-content: space-around;
    flex-direction: row;
    height: 14%;
  }

.btn-cookies {
    margin: 16.1vw 0 0 -5vw
    font-size: 2vw!important;
    padding: 2vw 3vw 4vw 3vw;
    height: 9%;
    display: flex;
    border: .2vw solid;
    margin-right: 2%;
}
.bannerCookies p {
    font-size: 3.6vw;
    padding: 1.5vw .5vw .5vw 4.5vw;
    margin-left: -1%;
 }

.bannerCookies table {
    max-width:20%;
    font-family: Wood-Bonnet-Grotesque!important;
    font-size: 1.7vw!important;
    
  } 

.bannerCookies th {
    font-size: 2vw
  }   

.bannnerCookies td {
    font-size: 2vw;
    padding-left: 6px;
 }  
}

@media only screen and (min-width: 820px) and (max-width: 1180px) {
  
.bannerCookies {
    display: none;
    color: aliceblue;
    background: rgba(5, 5, 5, 0.8);
    padding: 1vw 3vw 37vw 1vw;
    /* margin-left: 2%; */
    position: fixed;
    min-width: 100%;
    bottom: -206.5px;
    height: 1.8%;
  }
 }
</style>
